export function cleanText(value: unknown): string | null {
  if (typeof value !== "string" && typeof value !== "number") {
    return null;
  }

  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function normalizeSearch(value: unknown): string {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function normalizePhone(value: unknown): string | null {
  const text = cleanText(value);

  if (!text) {
    return null;
  }

  const normalized = text.replace(/[^\d+]/g, "");
  return normalized.length > 0 ? normalized : text;
}

export function displayValue(value: string | null | undefined, fallback = "Not set"): string {
  return value && value.trim().length > 0 ? value : fallback;
}

export function generateId(prefix: string): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return `${prefix}_${crypto.randomUUID()}`;
  }

  return `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}
